import React, { useState } from "react";
import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
} from "reactstrap";

const RuleEngineCard = ({ cid, lid }) => {
  const [loading, setLoading] = useState(false);

  const fetchDataAndOpenTab = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      const url = `/rule/engien/${cid}/${lid}`;
      window.open(url, "_blank");
    }, 50);
  };

  return (
    <Col xs="6" sm="4" md="3">
      <div onClick={fetchDataAndOpenTab} style={{ cursor: "pointer" }}>
        <Card className="card-stats mb-4">
          <CardBody>
            <Row>
              <div className="col">
                <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                  Rule Engine
                </CardTitle>
                <span className="h2 font-weight-bold mb-0 text-success">
                  {loading ? "Loading..." : "View"}
                </span>
              </div>
            </Row>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default RuleEngineCard;
